const LinkArrowRight = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.5 4.16663L18.3333 9.99996M18.3333 9.99996L12.5 15.8333M18.3333 9.99996H1.66666'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default LinkArrowRight
